export var StorageEvents;
(function (StorageEvents) {
    StorageEvents["ON_STORE_ACCESS_TOKEN"] = "on_store_access_token";
})(StorageEvents || (StorageEvents = {}));
//# sourceMappingURL=StorageEvents.js.map